import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';

// components
import { Button, Error, PhoneNumberInput } from '../shared/_form';

const New1 = function(props) {
  const errors = props.errors;
  const form   = props.form;

  return (
    <div className='rep-new__signup__step2'>
      <h2 className='panel__heading'>
        We need a little information about you
      </h2>
      <div className='form'>
        <form onSubmit={ props.onNextStep }>
          <input className='form__field form__field--rounded'
            name='name'
            onChange={ props.onFormChange }
            placeholder='Name'
            type='text'
            value={ form.name || '' } />
          <Error className='form__error--rounded'>{ errors.get('name') }</Error>
          <input className='form__field form__field--rounded'
            name='company'
            onChange={ props.onFormChange }
            placeholder='Company'
            type='text'
            value={ form.company || '' } />
          <Error className='form__error--rounded'>{ errors.get('company') }</Error>
          <input className='form__field form__field--rounded'
            name='specialty'
            onChange={ props.onFormChange }
            placeholder='Specialty'
            type='text'
            value={ form.specialty || '' } />
          <Error className='form__error--rounded'>{ errors.get('specialty') }</Error>
          <input className='form__field form__field--rounded'
            name='products'
            onChange={ props.onFormChange }
            placeholder='Products'
            type='text'
            value={ form.products || '' } />
          <Error className='form__error--rounded'>{ errors.get('products') }</Error>
          <PhoneNumberInput className='form__field form__field--rounded'
            name='phoneNumber'
            onChange={ props.onFormChange }
            placeholder='Phone Number'
            value={ form.phoneNumber || '' } />
          <Error className='form__error--rounded'>{ errors.get('phoneNumber') }</Error>
          <div className='form__submit'>
            <Button className='form__button form__button--green' loading={ props.loading }>Next</Button>
          </div>
        </form>
      </div>
    </div>
  );
};

New1.propTypes = {
  errors:       PropTypes.instanceOf(Immutable.Map),
  form:         PropTypes.instanceOf(Object),
  loading:      PropTypes.bool.isRequired,
  onFormChange: PropTypes.func.isRequired,
  onNextStep:   PropTypes.func.isRequired
};

export default New1;



// WEBPACK FOOTER //
// ./app/components/reps/_New2.jsx